import React, { useContext, useState } from 'react';
import { Input } from '@/shared/components';
import LanguageContext from '@/context/language';
import { useTranslation } from '@/app/i18n/client';

type Value = Object;
interface IProps {
  onSearch: (value: Value) => void;
}

export default function AdvancedSearch(props: IProps) {
  const { lang } = useContext(LanguageContext);
  const { t } = useTranslation(lang, 'orderhistory');
  const [orderNumber, setOrderNumber] = useState<string>('');
  const [accountNumber, setAccountNumber] = useState<string>('');
  const [catalogNumber, setCatalogNumber] = useState<string>('');
  const [productName, setProductName] = useState<string>('');
  const [purchaseOrderNumber, setPurchaseOrderNumber] = useState<string>('');
  const [webOrderNumber, setWebOrderNumber] = useState<string>('');

  const handleEnterKey = (e: React.KeyboardEvent<HTMLInputElement>, obj) => {
    if (e.key === 'Enter') {
      const tempObj = {
        ...(orderNumber && { orderNumber: orderNumber }),
        ...(accountNumber && { accountNumber: accountNumber }),
        ...(catalogNumber && { catalogNumber: catalogNumber }),
        ...(productName && { productName: productName }),
        ...(purchaseOrderNumber && { purchaseOrderNumber: purchaseOrderNumber }),
        ...(webOrderNumber && { webOrderNumber: webOrderNumber }),
      };
      props.onSearch(tempObj);
    }
  };
  const advancedSearch = [
    { title: t('order.number'), value: orderNumber, setValue: setOrderNumber, key: 'orderNumber' },
    {
      title: t('purchase.order.number'),
      value: purchaseOrderNumber,
      setValue: setPurchaseOrderNumber,
      key: 'purchaseOrderNumber',
    },
    { title: t('account.number'), value: accountNumber, setValue: setAccountNumber, key: 'accountNumber' },
    { title: t('catalog.number'), value: catalogNumber, setValue: setCatalogNumber, key: 'catalogNumber' },
    { title: t('product.name'), value: productName, setValue: setProductName, key: 'productName' },
    {
      title: t('order.reference.number'),
      value: webOrderNumber,
      setValue: setWebOrderNumber,
      key: 'webOrderNumber',
    },
  ];
  return (
    <div className="grid grid-cols-4 gap-x-8 gap-y-4 md:grid-cols-2 sm:grid-cols-1 grid-rows-2 mb-10">
      {advancedSearch.map((item, index) => {
        return (
          <div className="lg:p-4" key={index}>
            <Input
              className="w-full"
              label={item.title}
              placeholder={item.title}
              value={item.value}
              onChange={(e) => {
                item.setValue(e.target.value);
              }}
              onKeyDown={(e) => {
                const temp = {};
                temp[item.key] = item.value;
                handleEnterKey(e, temp);
              }}
            />
          </div>
        );
      })}
    </div>
  );
}
